import { Link } from 'react-router-dom';
import rating from '../../assets/images/rating-48.png';
import ratingIcon from '../../assets/images/ratingIcon.svg'
import {IMAGE_CDN} from "../utils/constants"

const ResCard = ({props}) => {
    const res = props;
    return (
        <Link to={"restaurent/"+res.info.id}>
            <div>
                <div>
                    <img className="w-52 h-36 rounded-2xl" src={IMAGE_CDN+res.info.cloudinaryImageId}></img>
                </div>
                <div className="pl-2 mt-2">
                    <div className="res-Name font-medium text-sm max-w-48">{res.info.name}</div>
                    <div className="flex text-xs font-medium items-center gap-1">
                        <img className='w-5 h-auto' src={'https://upload.wikimedia.org/wikipedia/commons/archive/b/b2/20220930232332%21Featured_Star_green.svg'}></img>
                        {res.info.avgRating}
                        &nbsp;• {res.info.sla.slaString}
                    </div>
                    <div className="text-xs overflow-hidden text-ellipsis whitespace-nowrap max-w-48">{res.info.cuisines.join(", ")}</div>
                    <div className="text-xs">{res.info.areaName}</div>
                </div>
            </div>
        </Link>
    );
};

export default ResCard;